import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { foundationCards } from '../../data/demoCenter';
import { fadeUp } from '../../utils/motion';
export function DemoFoundation() {
  return <section aria-labelledby="foundation-title" className="bg-white py-20 lg:py-28" data-id="element-227" data-mp="r56dhmgc5k3j">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228" data-mp="w1wwoinfsvt6">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12" data-id="element-229" data-mp="3vid0zx29f4lt">
          <h2 id="foundation-title" className="lg:col-span-5 font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-230" data-mp="3e10rg5oz7xg">
            Different domains. A connected foundation.
          </h2>
          <p className="lg:col-span-7 lg:pt-2 text-lg text-ink-muted leading-relaxed" data-id="element-231" data-mp="d5opvaes0cvr">
            Noetivra adapts the same underlying architecture to different work. Domain-specific views bring together the
            relevant records, methods and responsibilities.
          </p>
        </motion.div>

        <motion.ul {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-232" data-mp="3s3odt592y6rg">
          {foundationCards.map(card => <li key={card.name} className="flex bg-white" data-id="element-233" data-mp="3jauu8vmlol7s">
              <a href={card.href} className="group flex w-full flex-col p-6 lg:p-8 hover:bg-surface-bg transition-colors duration-150" data-id="element-234" data-mp="3edb4aygjik00">
                <h3 className="font-heading font-bold text-lg text-ink-dark" data-id="element-235" data-mp="34evdyxpc7erk">{card.name}</h3>
                <p className="mt-3 text-ink-muted leading-relaxed" data-id="element-236" data-mp="34h85o2kwd3ht">{card.body}</p>
                <span className="mt-auto pt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-navy group-hover:text-navy-light transition-colors duration-150" data-id="element-237" data-mp="30djvdc4vrtsv">
                  Learn more <ArrowRight size={14} aria-hidden="true" data-id="element-238" data-mp="ylezjpk9gccv" />
                </span>
              </a>
            </li>)}
        </motion.ul>

        <motion.div {...fadeUp} className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 rounded-xl border border-lavender/20 bg-lavender-pale p-6 lg:p-8" data-id="element-239" data-mp="1crpbedwzq9ai">
          <div className="lg:col-span-5" data-id="element-240" data-mp="13qr1xg3s99kj">
            <p className="text-sm font-medium text-lavender mb-2" data-id="element-241" data-mp="13s26vj8ysnd8">Shared across every domain</p>
            <h3 className="font-heading font-bold text-xl text-ink-dark" data-id="element-242" data-mp="18qn9fpbovj4u">Collaboration across organizations</h3>
          </div>
          <p className="lg:col-span-7 text-lg text-ink-dark leading-relaxed" data-id="element-243" data-mp="1wg7wokevl2jx">
            Share selected knowledge, coordinate reviews and connect services through authorized workflows. Each
            organization retains control over what it shares and who can access it.
          </p>
        </motion.div>
      </div>
    </section>;
}